"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wetTemperatureConversions = wetTemperatureConversions;
const calculations_1 = require("@munters/calculations");
function wetTemperatureConversions(fromAmount, to, conversionParameters) {
    const pressureAmount = conversionParameters.pressure;
    const temperatureAmount = conversionParameters.temperature;
    switch (to) {
        case "RelativeHumidity": {
            return calculations_1.Physics.RP1485.AmountConversions.wetTemperatureToRelativeHumidity(pressureAmount, temperatureAmount, fromAmount);
        }
        case "HumidityRatio": {
            return calculations_1.Physics.RP1485.AmountConversions.wetTemperatureToHumidityRatio(pressureAmount, temperatureAmount, fromAmount);
        }
        case "DewPointTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.wetTemperatureToDewPointTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        case "SpecificEnthalpy": {
            return calculations_1.Physics.RP1485.AmountConversions.wetTemperatureToSpecificEnthalpy(pressureAmount, temperatureAmount, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
//# sourceMappingURL=wet-temperature-conversions.js.map